import React from 'react';
import LegalPageEditor from '../Componant/LegalPageEditor';

export default function CGVSettingsPage() {
    return (
        <LegalPageEditor
            settingKey="terms_of_sale"
            heading="Conditions générales de vente"
            description="Affiché sur la page /cgv du site public, ainsi que sur la page d'acceptation des devis (lien + case à cocher obligatoire avant paiement). Modalités de paiement, droit de rétractation, garanties, litiges..."
            backTo="/settings"
            backLabel="Retour aux réglages"
        />
    );
}
